import { Route, Routes } from "react-router-dom";
import "./App.css";
import Amthal from "./component/amthal/Amthal";
import Home from "./component/home/Home";
import Nav from "./component/home/header/Nav";
import Gallery from "./component/gallary/Gallery";

const App = () => {
  return (
    <>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/amthal" element={<Amthal />} />
        <Route path="/gallery" element={<Gallery />} />
      </Routes>
    </>
  );
};

export default App;
